import type { QuestionGrid } from '@mentimeter/http-clients';
import { DEFAULT_GRID, DEFAULT_RATING_GRIDS } from '@mentimeter/rating-grids';

export const getRatingGrid = (questionGrid: QuestionGrid | undefined) => {
  const predefined = DEFAULT_RATING_GRIDS.find(
    (g) => g.id === questionGrid?.id,
  );
  if (predefined) {
    return {
      ...predefined,
      ...questionGrid,
    };
  }
  if (questionGrid?.url) return questionGrid;

  return DEFAULT_GRID;
};
